import React from "react";

import { QuestionnaireRow } from "components/AttachmentForm/Components";
import {
  DatePurchasedOptionsToggler,
  NVDOptionToggler,
  NVD_OPTIONS,
} from "components/AttachmentForm/NVDOptionToggles";
import { Input } from "components/Form/FormikControls";
import { Column } from "components/Layout";
import { useFormikContext } from "formik";
import { CandidateDeclarationSuggestion } from "../CandidateDeclarationSuggestions";

export const E0413 = ({ candidateDeclarationId }) => {
  const formikProps = useFormikContext();
  return (
    <Column>
      <QuestionnaireRow>
        <NVDOptionToggler
          name="declaration.fed_feed_containing_animal_fats"
          label="1."
        />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.fed_feed_containing_animal_fats"
        />
      </QuestionnaireRow>

      <QuestionnaireRow>
        <NVDOptionToggler name="declaration.owned_since_birth" label="2." />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.owned_since_birth"
        />
        {formikProps.values.declaration.owned_since_birth ===
          NVD_OPTIONS.NO && (
          <QuestionnaireRow>
            <DatePurchasedOptionsToggler
              name="declaration.owned_since_birth_duration"
              label=""
            />
            <CandidateDeclarationSuggestion
              candidateDeclarationId={candidateDeclarationId}
              fieldName="declaration.owned_since_birth_duration"
            />
          </QuestionnaireRow>
        )}
      </QuestionnaireRow>

      <QuestionnaireRow>
        <NVDOptionToggler
          name="declaration.fed_byproduct_stockfeeds"
          label="3."
        />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.fed_byproduct_stockfeeds"
        />
      </QuestionnaireRow>

      <QuestionnaireRow>
        <NVDOptionToggler
          name="declaration.chemical_residue_restrictions"
          label="4."
        />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.chemical_residue_restrictions"
        />
      </QuestionnaireRow>

      <QuestionnaireRow>
        <NVDOptionToggler name="declaration.veterinary_treatment" label="5." />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.veterinary_treatment"
        />
      </QuestionnaireRow>

      <QuestionnaireRow>
        <NVDOptionToggler
          name="declaration.consumed_material_in_withholding_period"
          label="6."
        />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.consumed_material_in_withholding_period"
        />
      </QuestionnaireRow>

      <QuestionnaireRow>
        <NVDOptionToggler name="declaration.spray_drift_risk" label="7." />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.spray_drift_risk"
        />
      </QuestionnaireRow>

      <QuestionnaireRow>
        <Input name="declaration.additional_information" label="8." />
        <CandidateDeclarationSuggestion
          candidateDeclarationId={candidateDeclarationId}
          fieldName="declaration.additional_information"
        />
      </QuestionnaireRow>
    </Column>
  );
};
